import React, { Component } from 'react';
import { Alert } from 'reactstrap';
import WreckAPI from '../lib/wreck_api.js';
import GoogleMapOfWrecks from '../components/google_map_of_wrecks.js';
import WreckDetailModal from '../components/wreck_detail_modal.js';

class WreckMap extends Component {
  state = { wrecks: [], selectedWreck: "", openModal: null }

  componentWillMount(){
    WreckAPI.getWrecks('UK-001').then(({wrecks}) => {
      console.log("Finished fetching wrecks")
      this.setState(() => ({
        wrecks: wrecks
      }))
    })
  }

  showWreckDetail = (wreck) => {
    this.setState(() => ({
      selectedWreck: wreck,
      openModal: Math.random()
    }))
  }

  render() {
    const LayoutWrapper = this.props.layout
    const hasWrecks = this.state.wrecks.length > 0;

    let conditionalMapElement
    if (hasWrecks) {
      conditionalMapElement = <GoogleMapOfWrecks wrecks={this.state.wrecks} showWreckDetailHandler={this.showWreckDetail}/>
    } else {
      conditionalMapElement = <Alert color="dark">Loading wrecks...</Alert>
    }

    return (
      <LayoutWrapper>
        <div className="page">
          <h2>Wreck Map</h2>
          <WreckDetailModal wreck={this.state.selectedWreck} open={this.state.openModal} />
          {conditionalMapElement}
        </div>
      </LayoutWrapper>
    )
  }
}

export default WreckMap;



// WEBPACK FOOTER //
// ./src/pages/wreck_map.js